<template>
  <modal v-on:closeModalRequest="closeModalRequest()">
    <div class="modal-change-email scrollable -y">
      <div class="header">
        <div class="title">Change Account Email</div>
        <div class="description">Please double check the new email address before you making this request.</div>
      </div>
      <transition name="text" mode="out-in" appear>
        <div
        v-if="message"
        v-bind:class="{
          error: !isSuccess
        }"
        class="message">{{message}}</div>
      </transition>
      <form
      v-on:submit="onClickSubmit"
      class="body">
        <div class="content">
          <div class="info-container">
            <div class="label">Current email address</div>
            <input id="new-email" type="email" v-model="myEmail" disabled>
          </div>
          <div class="info-container">
            <div class="label">New email address</div>
            <input id="new-email" type="email" v-model="newEmail" ref="new-email">
          </div>
          <div class="action-btns flex-end">
            <div
            v-on:click="closeModalRequest()" ontouchstart=""
            class="action-btn">Cancel</div>
            <input
            id="change-email"
            type="submit" value="Request change"
            class="action-btn blue" />
          </div>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  name: 'modal-change-email',
  components: {
    Modal
  },
  computed: {
    myEmail: function () {
      return this.$store.getters.myEmail
    },
    statusSendEmailChangeEmail: function () {
      return this.$store.getters.statusSendEmailChangeEmail
    }
  },
  data: function () {
    return {
      newEmail: null,
      message: null,
      isSuccess: true
    }
  },
  created: function () {
    this.setInputFocused()
  },
  methods: {
    closeModalRequest: function (reload = false) {
      this.$emit('closeModalRequest')
      if (reload) setTimeout(() => { this.getMyProfile() }, 1000)
    },
    onClickSubmit: function (e) {
      e.preventDefault()
      if (this.statusSendEmailChangeEmail === 'requested') {
        this.$logger.warn('Still in requesting to send the email change email.')
      } else {
        this.message = null
        this.isSuccess = true
        this.changeMyEmail().then(
          resp => {
            this.message = `We've just sent you an email to your new email address(${this.newEmail}) to confirm your request.`
            this.isSuccess = true
            // this.closeModalRequest()
          },
          err => {
            this.message = err.message
            this.isSuccess = false
            // this.closeModalRequest()
          }
        )
      }
    },
    setInputFocused: function () {
      this.$nextTick(() => {
        if (this.$refs['new-email']) {
          this.$refs['new-email'].focus()
        } else {
          setTimeout(() => {
            if (this.$refs['new-email']) {
              this.$refs['new-email'].focus()
            }
          }, 1000)
        }
      })
    },
    getMyProfile: function () {
      return this.$store.dispatch('getMyProfile')
    },
    changeMyEmail: function () {
      let email = this.newEmail
      return this.$store.dispatch('changeMyEmail', {email})
    }
  }
}
</script>

<style scoped>
.modal-change-email {
  /* common */
  background-color: hsla(0, 100%, 100%, 1);
  font-size: 11px;
  border-radius: 5px;
  /* size */
  max-width: 500px;
  max-height: 100%;
  width: 100%;
}

.modal-change-email .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 32px 20px;
  /* text */
  font-weight: bold;
  /* alignment */
  text-align: left;
}
.modal-change-email .header .title {
  /* common */
  font-size: 2em;
}
.modal-change-email .header .description {
  /* common */
  font-size: 1em;
  /* text */
  font-weight: normal;
}



.modal-change-email .message {
  /* common */
  background-color: hsla(202, 100%, 50%, 1);
  color: #fff;
  /* text */
  text-transform: uppercase;
  font-weight: bold;
  /* size */
  width: calc(100% - 2em);
  /* height: 3em; */
  padding: 1em;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.modal-change-email .message.error {
  /* common */
  background-color: hsla(0, 100%, 65%, 1);
  color: #fff;
}


.modal-change-email .body {
  /* size */
  padding: 0 32px;
  /* border */
  border-top: 1px solid hsla(0, 100%, 0%, 0.1);
  /* alignment */
  text-align: left;
}

.modal-change-email .body .content {
  /* common */
  color: #000;
  font-size: 16px;
  /* size */
  width: 100%;
  min-height: 4em;
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}


.modal-change-email .body .content .info-container:first-child {
  margin-top: 0;
}
.modal-change-email .body .content .info-container {
  /* size */
  margin: 1em 0;
}
.modal-change-email .body .content .info-container > input:disabled {
  /* common */
  background-color: hsla(0, 100%, 0%, 1);
  color: hsla(0, 100%, 100%, 1);
  /* text */
  font-weight: bold;
}





.modal-change-email .body .content .action-btns {
  /* size */
  margin: 1em 0 2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

</style>



// WEBPACK FOOTER //
// src/components/Modal/ModalChangeEmail.vue